//shift.transactionItem
export function calculateTotalizerVariance(beginningTotalizer, endingTotalizer, salesInLiters) {
  const actualDifference = endingTotalizer - beginningTotalizer;
  const variance = salesInLiters - actualDifference;

  const variancePercentage = actualDifference !== 0 ? (variance / actualDifference) * 100 : 0;
  const isNegative = salesInLiters < 0 && variance < 0;

  const truncatedPercentage = Math.trunc(variancePercentage * 100) / 100;

  return {
    variance: variance.toFixed(3),
    variancePercentage: truncatedPercentage.toFixed(2),
    isNegative: isNegative,
    formattedDisplay: `${variance.toFixed(3)} L (${truncatedPercentage.toFixed(2)}%)`,
    color: isNegative ? "red" : "black",
  };
}

export function getPumpNumber(pump) {
  return Number(pump?.match(/\d+/)?.[0] ?? 0);
}
